import React, { useEffect, useMemo, useState } from "react";
import http from "../../api/http"; // ✅ adapte le chemin si besoin
import "./partnersCarousel.css";
import { useBrand } from "../../context/brand-context";
export default function PartnersCarousel() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  const [perView, setPerView] = useState(4);
  const [index, setIndex] = useState(0);
 const { brand } = useBrand(); // Récupération de la marque actuelle
  const isAmen = brand === "amen";
  // Rouge pour Amen (#BF2A37), Bleu pour MG (#2563eb)
  const underlineColor = isAmen ? "#7a0f18" : "#2563eb";
  // responsive: 4 / 3 / 2 / 1
  useEffect(() => {
    const onResize = () => {
      const w = window.innerWidth;
      if (w <= 520) setPerView(1);
      else if (w <= 900) setPerView(2);
      else if (w <= 1200) setPerView(3);
      else setPerView(4);
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // ✅ fetch via axios instance
  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        setLoading(true);
        setErr("");

        // x-db obligatoire : sinon le backend prend la base par défaut (Amen) même en MG
        const { data } = await http.get("/api/partenaires", {
          headers: { "x-db": isAmen ? "Amen" : "Amen_C" },
        });
        const cleaned = Array.isArray(data)
          ? data
              .map((x) => ({ urlimg: String(x?.urlimg || "").trim() }))
              .filter((x) => x.urlimg)
          : [];

        if (mounted) setItems(cleaned);
      } catch (e) {
        const msg =
          e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "Erreur";
        if (mounted) setErr(msg);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [isAmen]);

  const maxIndex = useMemo(() => Math.max(0, items.length - perView), [items.length, perView]);

  useEffect(() => {
    setIndex((i) => Math.min(i, maxIndex));
  }, [maxIndex]);

  const translatePct = useMemo(() => (index * 100) / perView, [index, perView]);

  const canPrev = index > 0;
  const canNext = index < maxIndex;

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(maxIndex, i + 1));

  return (
    <section className="partners">
      <div className="section-header">
        <h2 className="section-title">NOS PARTENAIRES</h2>
        <div 
          className="section-underline" 
          style={{ backgroundColor: underlineColor }}
        ></div>
      </div>

      <div className="partners__frame">
        <button
          type="button"
          className={`partners__arrow partners__arrow--left ${canPrev ? "" : "is-disabled"}`}
          onClick={prev}
          aria-label="Précédent"
          disabled={!canPrev}
        >
          ‹
        </button>

        <div className="partners__viewport">
          <div
            className="partners__track"
            style={{ transform: `translateX(-${translatePct}%)` }}
          >
            {(loading ? Array.from({ length: perView }) : items).map((it, i) => {
              const url = loading ? "" : it.urlimg;
              return (
                <div
                  className="partners__slide"
                  key={loading ? `sk-${i}` : `${url}-${i}`}
                  style={{ flex: `0 0 ${100 / perView}%` }}
                >
                  <div className={`partners__card ${loading ? "is-skel" : ""}`}>
                    {!loading && url ? (
                      <img src={url} alt="" loading="lazy" className="partners__img" />
                    ) : (
                      <div className="partners__ph" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <button
          type="button"
          className={`partners__arrow partners__arrow--right ${canNext ? "" : "is-disabled"}`}
          onClick={next}
          aria-label="Suivant"
          disabled={!canNext}
        >
          ›
        </button>
      </div>

      {err && <div className="partners__error">Erreur: {err}</div>}
    </section>
  );
}
